import React from "react";
import { FormProvider } from "react-hook-form";
import PropTypes from "prop-types";

import "./Form.css";

export function Form({ id, children, onSubmit, ...formProps }) {
  return (
    <FormProvider {...formProps}>
      <form id={id} data-test={id} onSubmit={formProps.handleSubmit(onSubmit)}>
        {children}
      </form>
    </FormProvider>
  );
}

Form.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

Form.defaultProps = {
  id: undefined,
};

export default Form;
